import { render, staticRenderFns } from "./ResourceManagement.vue?vue&type=template&id=3a8cd740&scoped=true"
import script from "./ResourceManagement.vue?vue&type=script&lang=js"
export * from "./ResourceManagement.vue?vue&type=script&lang=js"
import style0 from "./ResourceManagement.vue?vue&type=style&index=0&id=3a8cd740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cd740",
  null
  
)

export default component.exports